<template>
    <div v-bind:class="{ 'has-danger' : error !== null, 'form-group': !noFormGroup, 'row': !noRow, 'display-contents': noWrapper }">
        <label :class="labelClasses" class="form-control-label  col-form-label" :for="name">{{ labelComputed }}</label>
        <div :class="inputHolderClasses">
            <multiselect
                ref="select"
                :id="name"
                :name="name"
                v-model="model"
                :options="options"
                :placeholder="placeholderText"
                :label="objectNameKey"
                :loading="loading"
                :track-by="trackBy"
                :multiple="multiple"
                :required="required"
                :close-on-select="closeOnSelect"
                :custom-label="customLabel"
                :open-direction="direction"
                :allow-empty="allowEmpty"
                :autofocus="autofocus"
                :selectedLabel="uLang('app.select')"
                :selectLabel="uLang('app.press_enter_to_select')"
                :deselectLabel="uLang('app.press_enter_to_remove')"
                :disabled="disabled"
                @select="onSelect"
                @input="triggerInput"
                autocomplete="off"
                v-bind="$attrs"
            >
                <template slot="option" slot-scope="props" v-if="country">
                    <span class="option__title float-left">{{ props.option.name }}</span>
                    <img class="option__image float-right" :src="'https://www.geonames.org/flags/x/' + props.option.iso_3166_2.toLowerCase() + '.gif'" :alt="props.option.name">
                </template>
                <p slot="noResult">{{ uLang('app.no_results_found_change_query') }}</p>
            </multiselect>
            <span class="help-block form-control-feedback" v-if="error != null"
                  v-text="error"></span>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import ElementMixin from '~/mixins/element'
export default {
    name: 'form-select',
    mixins: [ElementMixin],
    components: {
        Multiselect
    },

    props: {
        objectNameKey: {
            type: String,
            required: false,
            default: 'name',
        },
        noFormGroup: {
            type: Boolean,
            required: false,
            default: false,
        },
        noRow: {
            type: Boolean,
            required: false,
            default: false,
        },
        noWrapper: {
            type: Boolean,
            required: false,
            default: false,
        },
        value: {
            default: null,
        },
        trackBy: {
            type: String,
            default: 'name',
            required: false,
        },
        loading: {
            type: Boolean,
            default: false,
            required: false,
        },
        labelClasses: {
            type: String,
            required: false,
            default: 'col-md-3 col-xl-2 col-sm-12',
        },
        inputHolderClasses: {
            type: String,
            required: false,
            default: 'col-md-9 col-xl-10 col-sm-12'
        },
        noLabel: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Array,
            required: true,
        },
        customLabel: {
            required: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        closeOnSelect: {
            type: Boolean,
            default: true,
        },
        direction: {
            type: String,
            default: '',
        },
        allowEmpty: {
            type: Boolean,
            default: true,
        },
        onSelect: {
            type: Function,
            default: () => {},
        },
        country: {
            type: Boolean,
            default: false,
        },
        onInput: {
            type: Function,
            default: () => {},
        },
    },
    watch: {
        value: function(val) {
            this.model = val;
        }
    },
    created: function() {
        this.model = this.value;
    },

    computed: {
        placeholderText() {
            return this.placeholder || this.uLang('app.select_an_option');
        }
    },

    methods: {
        triggerInput(value) {
            this.$emit('keydown', value); // Fix so that errors disappear in form
            this.onInput(value);
        },
    },
  }
</script>

<style lang="css" scoped>
.display-contents {
    display: contents;
}
.option__image {
    max-width: 30px;
    max-height: 20px;
}
</style>
